import { render, staticRenderFns } from "./CouncilReport.vue?vue&type=template&id=6ec5bff2&scoped=true&"
import script from "./CouncilReport.vue?vue&type=script&lang=js&"
export * from "./CouncilReport.vue?vue&type=script&lang=js&"
import style0 from "./CouncilReport.vue?vue&type=style&index=0&id=6ec5bff2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec5bff2",
  null
  
)

export default component.exports